export default "__VITE_ASSET__D1z_aO4C__"